module.exports = __webpack_public_path__ + "static/media/threaded-message.2c5da494.svg";